<script>
import router from "@/router"
import { SimpleBar } from "simplebar-vue3"
import { layoutComputed } from "@/state/helpers"
import Menu from "@/components/menu.vue"
import NavBar from "@/components/nav-bar"
import RightBar from "@/components/right-bar"
import Footer from "@/components/footer"

/**
 * Vertical layout
 */
export default {
  components: {
    NavBar,
    RightBar,
    Footer,
    SimpleBar,
    Menu,
  },
  data() {
    return {
      isMenuCondensed: false,
      rmenu: localStorage.getItem("rmenu")
        ? localStorage.getItem("rmenu")
        : "twocolumn",
    }
  },

  computed: {
    ...layoutComputed,
    isAdmin: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "admin" &&
          this.$store.getters.isAdmin
          ? true
          : false
      },
    },

    isOperator: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "operator" &&
          this.$store.getters.isOperator
          ? true
          : false
      },
    },

    isSeller: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "seller" &&
          this.$store.getters.isSeller
          ? true
          : false
      },
    },
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal")
    document.body.removeAttribute("data-topbar", "dark")
    document.body.removeAttribute("data-layout-size", "boxed")
  },
  methods: {
    initActiveMenu() {
      const pathName = window.location.pathname
      const ul = document.getElementById("navbar-nav")
      if (ul) {
        const items = Array.from(ul.querySelectorAll("a.nav-link"))
        let activeItems = items.filter((x) => x.classList.contains("active"))
        this.removeActivation(activeItems)
        let matchingMenuItem = items.find((x) => {
          return x.getAttribute("href") === pathName
        })
        if (matchingMenuItem) {
          this.activateParentDropdown(matchingMenuItem)
        } else {
          var id = pathName.replace("/", "")
          if (id) document.body.classList.add("twocolumn-panel")
          this.activateIconSidebarActive(pathName)
        }
      }
    },

    updateMenu(e) {
      document.body.classList.remove("twocolumn-panel")
      const ul = document.getElementById("navbar-nav")
      if (ul) {
        const items = Array.from(ul.querySelectorAll(".show"))
        items.forEach((item) => {
          item.classList.remove("show")
        })
      }
      const icons = document.getElementById("two-column-menu")
      if (icons) {
        const activeIcons = Array.from(
          icons.querySelectorAll(".nav-icon.active")
        )
        activeIcons.forEach((item) => {
          item.classList.remove("active")
        })
      }
      document.getElementById(e).classList.add("show")
      this.activateIconSidebarActive("#" + e)
    },

    removeActivation(items) {
      items.forEach((item) => {
        if (item.classList.contains("menu-link")) {
          if (!item.classList.contains("active")) {
            item.setAttribute("aria-expanded", false)
          }
          item.nextElementSibling.classList.remove("show")
        }
        if (item.classList.contains("nav-link")) {
          if (item.nextElementSibling) {
            item.nextElementSibling.classList.remove("show")
          }
          item.setAttribute("aria-expanded", false)
        }
        item.classList.remove("active")
      })
    },

    activateIconSidebarActive(id) {
      var menu = document.querySelector(
        "#two-column-menu .simplebar-content-wrapper a[href='" +
          id +
          "'].nav-icon"
      )
      if (menu !== null) {
        menu.classList.add("active")
      }
    },

    activateParentDropdown(item) {
      // navbar-nav menu add active
      item.classList.add("active")
      let parentCollapseDiv = item.closest(".collapse.menu-dropdown")
      if (parentCollapseDiv) {
        // to set aria expand true remaining
        parentCollapseDiv.classList.add("show")
        parentCollapseDiv.parentElement.children[0].classList.add("active")
        parentCollapseDiv.parentElement.children[0].setAttribute(
          "aria-expanded",
          "true"
        )
        if (
          parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")
        ) {
          if (
            parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")
              .previousElementSibling
          ) {
            if (
              parentCollapseDiv.parentElement
                .closest(".collapse.menu-dropdown")
                .previousElementSibling.parentElement.closest(
                  ".collapse.menu-dropdown"
                )
            ) {
              const grandparent = parentCollapseDiv.parentElement
                .closest(".collapse.menu-dropdown")
                .previousElementSibling.parentElement.closest(
                  ".collapse.menu-dropdown"
                )
              this.activateIconSidebarActive(
                "#" + grandparent.getAttribute("id")
              )
              grandparent.classList.add("show")
            }
          }
          this.activateIconSidebarActive(
            "#" +
              parentCollapseDiv.parentElement
                .closest(".collapse.menu-dropdown")
                .getAttribute("id")
          )

          parentCollapseDiv.parentElement
            .closest(".collapse")
            .classList.add("show")
          if (
            parentCollapseDiv.parentElement.closest(".collapse")
              .previousElementSibling
          )
            parentCollapseDiv.parentElement
              .closest(".collapse")
              .previousElementSibling.classList.add("active")
          return false
        }
        this.activateIconSidebarActive(
          "#" + parentCollapseDiv.getAttribute("id")
        )
        return false
      }
      return false
    },

    toggleMenu() {
      document.body.classList.toggle("sidebar-enable")

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable")
          document.body.classList.remove("vertical-collpsed")
        })
        document.body.classList.toggle("vertical-collpsed")
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable")
        })
        document.body.classList.remove("vertical-collpsed")
      }
      this.isMenuCondensed = !this.isMenuCondensed
    },

    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled")
    },

    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled")
    },
  },

  mounted() {
    this.initActiveMenu()
    if (this.rmenu == "vertical" && this.layoutType == "twocolumn") {
      document.documentElement.setAttribute("data-layout", "vertical")
    }
    document.getElementById("overlay").addEventListener("click", () => {
      document.body.classList.remove("vertical-sidebar-enable")
    })

    window.addEventListener("resize", () => {
      if (this.layoutType == "twocolumn") {
        var windowSize = document.documentElement.clientWidth
        if (windowSize < 767) {
          document.documentElement.setAttribute("data-layout", "vertical")
          this.rmenu = "vertical"
          localStorage.setItem("rmenu", "vertical")
        } else {
          document.documentElement.setAttribute("data-layout", "twocolumn")
          this.rmenu = "twocolumn"
          localStorage.setItem("rmenu", "twocolumn")
          setTimeout(() => {
            this.initActiveMenu()
          }, 50)
        }
      }
    })
  },
}
</script>

<template>
  <div id="layout-wrapper">
    <NavBar />
    <div>
      <!-- ========== Left Sidebar Start ========== -->
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- Dark Logo-->
          <router-link :to="{ name: 'dashboard' }" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt="" height="17" />
            </span>
          </router-link>
          <!-- Light Logo-->
          <router-link :to="{ name: 'dashboard' }" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt="" height="17" />
            </span>
          </router-link>
          <button
            type="button"
            class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i class="ri-record-circle-line"></i>
          </button>
        </div>

        <div id="scrollbar" v-if="rmenu == 'twocolumn'">
          <b-container fluid>
            <div id="two-column-menu">
              <SimpleBar class="twocolumn-iconview list-unstyled">
                <b-link href="#" class="logo"
                  ><img
                    src="@/assets/images/logo-sm.png"
                    alt="Logo"
                    height="22"
                /></b-link>

                <li class="nav-item">
                  <router-link
                    class="nav-icon"
                    :to="
                      isAdmin || isOperator
                        ? { name: 'dashboard' }
                        : { name: 'store.dashboard' }
                    "
                  >
                    <i class="mdi mdi-speedometer"></i>
                  </router-link>
                </li>

                <li class="nav-item" v-if="isAdmin">
                  <router-link class="nav-icon" :to="{ name: 'operators' }">
                    <i class="mdi mdi-account-supervisor-outline"></i>
                  </router-link>
                </li>

                <li>
                  <b-link
                    class="nav-icon"
                    href="#sidebarProducts"
                    role="button"
                    @click.prevent="updateMenu('sidebarProducts')"
                  >
                    <i class="mdi mdi-cube-outline"></i>
                  </b-link>
                </li>

                <li class="nav-item" v-if="isAdmin || isOperator">
                  <router-link class="nav-icon" :to="{ name: 'users' }">
                    <i class="mdi mdi-account-group-outline"></i>
                  </router-link>
                </li>

                <li v-if="isAdmin || isOperator">
                  <b-link
                    class="nav-icon"
                    href="#sliderbanner"
                    role="button"
                    @click.prevent="updateMenu('sliderbanner')"
                  >
                    <i class="mdi mdi-image-multiple-outline"></i>
                  </b-link>
                </li>

                <li class="nav-item" v-if="isAdmin || isOperator">
                  <router-link class="nav-icon" :to="{ name: 'stores' }">
                    <i class="mdi mdi-storefront-outline"></i>
                  </router-link>
                </li>

                <li class="nav-item" v-if="isAdmin">
                  <router-link class="nav-icon" :to="{ name: 'settings' }">
                    <i class="mdi mdi-cog-outline"></i>
                  </router-link>
                </li>

                <li class="nav-item" v-if="isAdmin || isOperator">
                  <router-link class="nav-icon" :to="{ name: 'orders' }">
                    <i class="mdi mdi-shopping-outline"></i>
                  </router-link>
                </li>

                <li class="nav-item" v-else-if="isSeller">
                  <router-link class="nav-icon" :to="{ name: 'store.orders' }">
                    <i class="mdi mdi-shopping-outline"></i>
                  </router-link>
                </li>

                <li class="nav-item" v-if="isAdmin || isOperator">
                  <router-link class="nav-icon" :to="{ name: 'messages' }">
                    <i class="mdi mdi-message-text-outline"></i>
                  </router-link>
                </li>

                <li class="nav-item" v-if="isAdmin || isOperator">
                  <router-link
                    class="nav-icon"
                    :to="{ name: 'cooperation.requests' }"
                  >
                    <i class="mdi mdi-handshake-outline"></i>
                  </router-link>
                </li>

                <li>
                  <b-link
                    class="nav-icon"
                    href="#financial"
                    role="button"
                    @click.prevent="updateMenu('financial')"
                  >
                    <i class="mdi mdi-cash-multiple"></i>
                  </b-link>
                </li>

                <li v-if="isAdmin || isOperator">
                  <b-link
                    class="nav-icon"
                    href="#reminders"
                    role="button"
                    @click.prevent="updateMenu('reminders')"
                  >
                    <i class="mdi mdi-bell-ring-outline"></i>
                  </b-link>
                </li>
              </SimpleBar>
            </div>
            <template v-if="layoutType === 'twocolumn'">
              <SimpleBar class="navbar-nav" id="navbar-nav">
                <li class="nav-item">
                  <div class="collapse menu-dropdown" id="sidebarProducts">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="isAdmin || isOperator">
                        <router-link
                          :to="{ name: 'product.categories' }"
                          class="nav-link"
                          data-key="t-product-categories"
                        >
                          {{ $t("t-product-categories") }}
                        </router-link>
                      </li>

                      <li class="nav-item" v-if="isAdmin || isOperator">
                        <router-link
                          :to="{ name: 'product.attributes' }"
                          class="nav-link"
                          data-key="t-product-attributes"
                        >
                          {{ $t("t-product-attributes") }}
                        </router-link>
                      </li>

                      <li class="nav-item" v-if="isAdmin || isOperator">
                        <router-link
                          :to="{ name: 'attribute.values' }"
                          class="nav-link"
                          data-key="t-attribute-values"
                        >
                          {{ $t("t-attribute-values") }}
                        </router-link>
                      </li>

                      <li class="nav-item" v-if="isAdmin || isOperator">
                        <router-link
                          :to="{ name: 'tags' }"
                          class="nav-link"
                          data-key="t-tags"
                        >
                          {{ $t("t-tags") }}
                        </router-link>
                      </li>

                      <li class="nav-item">
                        <router-link
                          v-if="isAdmin || isOperator"
                          :to="{ name: 'product.products' }"
                          class="nav-link"
                          data-key="t-products"
                        >
                          {{ $t("t-products") }}
                        </router-link>

                        <router-link
                          v-else-if="isSeller"
                          :to="{ name: 'store.product.products' }"
                          class="nav-link"
                          data-key="t-products"
                        >
                          {{ $t("t-products") }}
                        </router-link>
                      </li>

                      <li class="nav-item" v-if="isAdmin || isOperator">
                        <router-link
                          :to="{ name: 'faqs' }"
                          class="nav-link"
                          data-key="t-faqs"
                        >
                          {{ $t("t-faqs") }}
                        </router-link>
                      </li>

                      <li class="nav-item" v-if="isAdmin || isOperator">
                        <router-link
                          :to="{ name: 'comments' }"
                          class="nav-link"
                          data-key="t-comments"
                        >
                          {{ $t("t-comments") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- end product Menu -->

                <li class="nav-item" v-if="isAdmin || isOperator">
                  <div class="collapse menu-dropdown" id="sliderbanner">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item">
                        <router-link
                          :to="{ name: 'sliders' }"
                          class="nav-link"
                          data-key="t-slider"
                        >
                          {{ $t("t-slider") }}
                        </router-link>
                      </li>
                      <li class="nav-item">
                        <router-link
                          :to="{ name: 'ads' }"
                          class="nav-link"
                          data-key="t-ads-banners"
                        >
                          {{ $t("t-ads-banners") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- end sliders and banners Menu -->

                <li class="nav-item">
                  <div class="collapse menu-dropdown" id="financial">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="isAdmin">
                        <router-link
                          :to="{ name: 'financial.transactions' }"
                          class="nav-link"
                          data-key="t-transactions"
                        >
                          {{ $t("t-transactions") }}
                        </router-link>
                      </li>

                      <li class="nav-item" v-if="isSeller">
                        <router-link
                          :to="{ name: 'store.products.unsettled' }"
                          class="nav-link"
                          data-key="t-unsettled-products"
                        >
                          {{ $t("t-unsettled-products") }}
                        </router-link>
                      </li>

                      <li class="nav-item" v-if="isSeller">
                        <router-link
                          :to="{ name: 'store.settlement.payments' }"
                          class="nav-link"
                          data-key="t-settlement-payments"
                        >
                          {{ $t("t-settlement-payments") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- end financial Menu -->

                <li class="nav-item" v-if="isAdmin || isOperator">
                  <div class="collapse menu-dropdown" id="reminders">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item">
                        <router-link
                          :to="{ name: 'occasion.occasions' }"
                          class="nav-link"
                          data-key="t-occasions"
                        >
                          {{ $t("t-occasions") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- end reminders Menu -->
              </SimpleBar>
            </template>
          </b-container>
        </div>

        <SimpleBar
          id="scrollbar"
          class="h-100"
          ref="scrollbar"
          v-if="rmenu == 'vertical'"
        >
          <Menu></Menu>
        </SimpleBar>

        <div class="sidebar-background"></div>
      </div>
      <!-- Left Sidebar End -->
      <!-- Vertical Overlay-->
      <div class="vertical-overlay" id="overlay"></div>
    </div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content">
      <div class="page-content">
        <!-- Start Content-->
        <b-container fluid>
          <slot />
        </b-container>
      </div>
      <Footer />
    </div>
    <RightBar />
  </div>
</template>
